import { stripeSupportedCountries } from "@/data/countries";

/**
 * Converts a country code to its full country name
 * @param countryCode - Two-letter country code (e.g., "US", "CA")
 * @returns Full country name or the original code if not found
 */
export const getCountryName = (countryCode: string): string => {
  if (!countryCode) return countryCode;

  // Check if it's already a full country name (for backwards compatibility)
  const isAlreadyFullName = stripeSupportedCountries.some(
    (c) => c.country.toLowerCase() === countryCode.toLowerCase(),
  );
  if (isAlreadyFullName) {
    return countryCode;
  }

  // Convert code to full name
  const country = stripeSupportedCountries.find(
    (c) => c.code.toUpperCase() === countryCode.toUpperCase(),
  );

  return country ? country.country : countryCode;
};
